import { render, staticRenderFns } from "./TemplatesWritingAssistant.vue?vue&type=template&id=655f2ee9&"
import script from "./TemplatesWritingAssistant.vue?vue&type=script&lang=ts&"
export * from "./TemplatesWritingAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesWritingAssistant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VRow,VTextField,VTextarea})
